import { defineStore } from 'pinia';
import { apiClient } from '@/lib/api/client';
import { CouponsWithImageUrl } from '@/lib/api/coupons.api';
import { useScannerCouponStore } from '@/store/useScannerCoupon';

export const useCouponImageStore = defineStore('couponImage', {
  state: () => ({
    scannerCoupon: useScannerCouponStore(),
  }),

  actions: {
    async uploadImage(file: Blob, item: CouponsWithImageUrl): Promise<void> {
      try {
        this.scannerCoupon.loading = true;

        const { response } = await apiClient.PATCH('/coupons/{id}/image', {
          params: {
            path: {
              id: item.id,
            },
          },
          body: { file: file.toString() },
          bodySerializer: () => {
            const formData = new FormData();
            formData.append('file', file);
            return formData;
          },
        });

        if (!response.ok) {
          throw new Error('Failed to upload image');
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.scannerCoupon.loading = false;
      }
    },
  },
});
